module.exports = __webpack_public_path__ + "static/media/028-check.54161258.svg";